module.exports = __webpack_public_path__ + "assets/6e2b61669c2d43cfafe694790a583042.png";